module.exports = require("@fortawesome/pro-regular-svg-icons/faPenToSquare");